/**
 * Three readings typed straight onto the felt: the contract, how the tricks are
 * running, and the score. No chips, no boxes — 44 px of fixed-cost height, as
 * measured in FINDINGS.
 */
import { Menu, ScorePad, Track } from './atoms'
import type { TableView } from './view'

export function StatusBand({ view, onMenu }: { view: TableView; onMenu: () => void }): JSX.Element {
  const reading = view.gameUi.contractReading(view)
  const auctioning = view.hand?.phase === 'auction' || view.hand?.phase === 'committing'
  const needed = view.gameUi.tricksNeeded(view.match)
  const caption = view.gameUi.trackCaption(view)

  return (
    <>
      <header className="status">
        <div className="reading">
          <div className="num index">{reading?.node ?? <span className="faint">—</span>}</div>
          <div className="cap">{reading?.caption ?? ''}</div>
        </div>
        <div className="reading" style={{ alignItems: 'center' }}>
          {auctioning ? (
            <div className="num index" style={{ fontSize: 17, marginTop: 2 }}>
              Hand {(view.match?.handIndex ?? 0) + 1}
            </div>
          ) : (
            <Track
              dots={view.trickDots}
              goal={needed}
              compact={view.tricksPerHand > 10}
              label={caption}
              fresh={freshDot(view)}
            />
          )}
          <div className="cap">{auctioning ? dealerCaption(view) : caption}</div>
        </div>
        <ScorePad us={view.scores.us} them={view.scores.them} />
      </header>
      <Menu onClick={onMenu} />
    </>
  )
}

/** Events are advisory and exist for exactly this: the dot pops because a trick
 *  was just won, not because two snapshots happened to differ. */
function freshDot(view: TableView): number | null {
  for (const tagged of view.snapshot.events) {
    if (tagged.event.type === 'trickWon') return view.trickDotSlot(tagged.event.trickIndex)
  }
  return null
}

function dealerCaption(view: TableView): string {
  const dealer = view.hand?.dealer ?? view.match?.dealer ?? null
  if (dealer === null) return ''
  return dealer === view.mySeat ? 'you dealt' : `${view.name(dealer)} dealt`
}
